import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';

import { SpaceService } from './../../../services/space.service';
import { MemberService } from './../../../rest/api/member.service';
import { AuthService } from './../../../services/auth.service';
@Component({
  selector: 'app-video-list',
  templateUrl: './video-list.component.html',
  styleUrls: ['./video-list.component.scss']
})
export class VideoListComponent implements OnInit {
  @Input() mediaData;
  @Output() deleteImageSpaceEmit = new EventEmitter();
  spaceData: any;
  loading = true;
  accessToken: any;
  isImage = false;
  checkAllImages  = false;
  selectAll = false;
  selectedVideo = [];
  constructor(
    public spaceService: SpaceService,
    public memberService: MemberService,
    private authService: AuthService,
    public router: Router
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.spaceService.spaceDataSubscription.subscribe(response => {
      if (Object.keys(response).length === 0 && response.constructor === Object) {
        this.router.navigate(['/member']);
      }
      if (response) {
        this.spaceData = response;
        this.getMediaDetails();
      }
    });
  }

  uploadVideoEmit(response) {
    this.loading = true;
    this.getMediaDetails();
    if (this.spaceData.media.images && this.spaceData.media.images) {
      this.spaceData.media.images = response;
    }
  }

  getMediaDetails() {
    this.memberService.getMemberSpaceMediaDetails({
      Authorization: this.accessToken,
      id: this.spaceData.uuid
    }).subscribe((response: any) => {
      const mediaData = response && response.media ? response.media : [];
      this.mediaData = _.map(mediaData, (media) => {
        media.checked = false;
        return media;
      });
      this.loading = false;
      this.spaceService.setSpaceMediaData(this.mediaData);
    }, err => {
      this.router.navigate(['/member']);
    });
  }

  mediaCheckChange(selectedMedia) {
    this.mediaData = _.map(this.mediaData, (media) => {
      if (selectedMedia.uuid === media.uuid) {
        media.checked = !media.checked;
      }
      return media;
    });
    this.selectAll = false;
    this.selectedVideo = _.filter(this.mediaData, {checked: true});
    if (this.selectedVideo.length === this.mediaData.length) {
      this.selectAll = true;
    }

  }

  mediaSelectAll() {
    this.selectAll = !this.selectAll;
    if (this.selectAll) {
      this.mediaData = _.map(this.mediaData, (media) => {
        media.checked = true;
        return media;
      });
      this.selectedVideo = this.mediaData;
    } else {
      this.mediaData = _.map(this.mediaData, (media) => {
        media.checked = false;
        return media;
      });
      this.selectedVideo = [];
    }
  }

  changeImagesByCategory(event) {
    if (event.target.name === 'images') {
      this.isImage = true;
    }

    if (this.isImage && this.checkAllImages) {
      event.target.checked = true;
    }
  }

  allSpaceImages(event) {
    const checked = event.target.checked;
    this.mediaData.forEach(item => item.selected = checked);
  }

  modalCloseEmit(response) {
    if (document.getElementById('modalClose')) {
      document.getElementById('modalClose').click();
    }

    if (response) {
      this.loading = true;
      this.getMediaDetails();
    }
  }

}
